<template>
  <div class="review-menu">
    <div class="dropdown">
      <button
          v-if="this.review.polarity === 'Niet beoordeelt'"
          class="dropbtn notGraded"
      >
        <font-awesome-icon icon="ellipsis-h"/>
      </button>
      <button v-else class="dropbtn">
        <font-awesome-icon icon="ellipsis-h"/>
      </button>
      <div class="dropdown-content">
        <a v-on:click="setPolarity('Neutraal', review)">Neutraal</a>
        <a v-on:click="setPolarity('Positief', review)">Positief</a>
        <a v-on:click="setPolarity('Negatief', review)">Negatief</a>
        <a v-on:click="irrelevant(review)">Verwijderen</a>
      </div>
    </div>
  </div>
</template>

<script>
import {central_api_domain} from "@/constants/endpoints";

export default {
  name: "ReviewMenu",
  props: {
    review: Object,
  },
  methods: {
    setPolarity(polarity, review) {
      review.polarity = polarity;
      review.graded = 1;
      this.ratePost(review);
    },
    irrelevant(review) {
      this.softDelete(review.id);
    },
    ratePost(review) {
      const url = central_api_domain + "posts/rate";

      let body = {
        postId: review.id,
        polarity: review.polarity
      }

      let fetchData = {
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      fetch(url, fetchData)
          .then((res) => res.json())
          .then(() => {
            this.updateParent();
          });

    },
    softDelete(reviewId) {
      const url = central_api_domain + "posts/delete";

      let body = {
        postId: reviewId,
      }

      let fetchData = {
        method: "PUT",
        body: JSON.stringify(body),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      fetch(url, fetchData)
          .then((res) => res.json())
          .then(() => {
            this.updateParent();
          });
    },
    updateParent() {
      this.$parent.updateParent();
    },
    updatePost(review) {
      const url = central_api_domain + "posts";
      let fetchData = {
        method: "PUT",
        body: JSON.stringify(review),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      fetch(url, fetchData)
          .then((res) => res.json())
          .then(() => {
            this.updateParent();
          });
    },
  },
};
</script>
